export default {
  index: [
    {
      path: '/InvoiceReport',
      component: resolve => require(['./InvoiceReportIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/InvoiceReport/_router.js